(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/Nothing', '../model/Wallpaper', '../model/SearchResult', '../model/ActiveWallpaperUpdate', '../model/FavoriteUploadResponse', '../model/FavoriteUploadRequest', '../model/WallpaperUploadResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/Nothing'), require('../model/Wallpaper'), require('../model/SearchResult'), require('../model/ActiveWallpaperUpdate'), require('../model/FavoriteUploadResponse'), require('../model/FavoriteUploadRequest'), require('../model/WallpaperUploadResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.VpersonalizationApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.Nothing, root.SmartCsV2Sdk.Wallpaper, root.SmartCsV2Sdk.SearchResult, root.SmartCsV2Sdk.ActiveWallpaperUpdate, root.SmartCsV2Sdk.FavoriteUploadResponse, root.SmartCsV2Sdk.FavoriteUploadRequest, root.SmartCsV2Sdk.WallpaperUploadResponse);
  }
}(this, function(ApiClient, Nothing, Wallpaper, SearchResult, ActiveWallpaperUpdate, FavoriteUploadResponse, FavoriteUploadRequest, WallpaperUploadResponse) {
  'use strict';

  /**
   * Vpersonalization service.
   * @module api/VpersonalizationApi
   * @version 2.0.624
   */

  /**
   * Constructs a new VpersonalizationApi. 
   * @alias module:api/VpersonalizationApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the deleteFavorite operation.
     * @callback module:api/VpersonalizationApi~deleteFavoriteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete favorite
     * @param {String} id 
     * @param {module:api/VpersonalizationApi~deleteFavoriteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteFavorite = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteFavorite";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/personalization/favorite/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteWallpaper operation.
     * @callback module:api/VpersonalizationApi~deleteWallpaperCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete wallpaper
     * @param {String} id 
     * @param {module:api/VpersonalizationApi~deleteWallpaperCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteWallpaper = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteWallpaper";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/personalization/wallpaper/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getActiveWallpaper operation.
     * @callback module:api/VpersonalizationApi~getActiveWallpaperCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Wallpaper} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get currently active wallpaper, if set
     * @param {module:api/VpersonalizationApi~getActiveWallpaperCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Wallpaper}
     */
    this.getActiveWallpaper = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Wallpaper;

      return this.apiClient.callApi(
        '/v2/personalization/wallpaper/active', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserFavorites operation.
     * @callback module:api/VpersonalizationApi~getUserFavoritesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SearchResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all favorites for the current user
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.limit 
     * @param {String} opts.nextPageToken 
     * @param {String} opts.sortBy 
     * @param {String} opts.resourceType 
     * @param {module:api/VpersonalizationApi~getUserFavoritesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/SearchResult}
     */
    this.getUserFavorites = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'limit': opts['limit'],
        'nextPageToken': opts['nextPageToken'],
        'sortBy': opts['sortBy'],
        'resourceType': opts['resourceType']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SearchResult;

      return this.apiClient.callApi(
        '/v2/personalization/favorite', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getUserWallpapers operation.
     * @callback module:api/VpersonalizationApi~getUserWallpapersCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SearchResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all wallpapers for the current user
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.limit 
     * @param {String} opts.nextPageToken 
     * @param {String} opts.sortBy 
     * @param {module:api/VpersonalizationApi~getUserWallpapersCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/SearchResult}
     */
    this.getUserWallpapers = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'limit': opts['limit'],
        'nextPageToken': opts['nextPageToken'],
        'sortBy': opts['sortBy']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SearchResult;

      return this.apiClient.callApi(
        '/v2/personalization/wallpaper', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setActiveWallpaper operation.
     * @callback module:api/VpersonalizationApi~setActiveWallpaperCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update active wallpaper.
     * Send empty id to unset existing value.
     * @param {module:model/ActiveWallpaperUpdate} activeWallpaperUpdate 
     * @param {module:api/VpersonalizationApi~setActiveWallpaperCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.setActiveWallpaper = function(activeWallpaperUpdate, callback) {
      var postBody = activeWallpaperUpdate;

      // verify the required parameter 'activeWallpaperUpdate' is set
      if (activeWallpaperUpdate == undefined || activeWallpaperUpdate == null) {
        throw "Missing the required parameter 'activeWallpaperUpdate' when calling setActiveWallpaper";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/personalization/wallpaper/active', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadFavorite operation.
     * @callback module:api/VpersonalizationApi~uploadFavoriteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FavoriteUploadResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set a new resource as favorite
     * @param {module:model/FavoriteUploadRequest} favoriteUploadRequest 
     * @param {module:api/VpersonalizationApi~uploadFavoriteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/FavoriteUploadResponse}
     */
    this.uploadFavorite = function(favoriteUploadRequest, callback) {
      var postBody = favoriteUploadRequest;

      // verify the required parameter 'favoriteUploadRequest' is set
      if (favoriteUploadRequest == undefined || favoriteUploadRequest == null) {
        throw "Missing the required parameter 'favoriteUploadRequest' when calling uploadFavorite";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = FavoriteUploadResponse;

      return this.apiClient.callApi(
        '/v2/personalization/favorite', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadWallpaper operation.
     * @callback module:api/VpersonalizationApi~uploadWallpaperCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WallpaperUploadResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload a new wallpaper image
     * @param {File} fileStream 
     * @param {module:api/VpersonalizationApi~uploadWallpaperCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/WallpaperUploadResponse}
     */
    this.uploadWallpaper = function(fileStream, callback) {
      var postBody = null;

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling uploadWallpaper";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'fileStream': fileStream
      };

      var authNames = [];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = WallpaperUploadResponse;

      return this.apiClient.callApi(
        '/v2/personalization/wallpaper', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
